import React from "react";
import { Route, Routes } from "react-router-dom";

import { Layout } from "./layout";

import Home from "./home";
import ChatLayout from "@/components/ChatLayout";

export default function Agency() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="chat/*" element={<ChatLayout basePath="/agency/chat" />} />
      </Route>
    </Routes>
  );
}
